var React = require('react');

function Left (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Composant_5_1","data-name":"Composant 5 – 1","transform":"translate(1.5 2.121)"},React.createElement("path",{"id":"Tracé_3","data-name":"Tracé 3","d":"M3329.306,2481.778l6.985,6.686-6.985,6.686","transform":"translate(3336.291 2495.15) rotate(180)","fill":"none","stroke":"#04152f","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"3"})));
}

Left.defaultProps = {"width":"10.605","height":"17.614","viewBox":"0 0 10.605 17.614"};

module.exports = Left;

Left.default = Left;
